import { Yellow } from '../../../styles/css';

const sources = [
    'mapbox-gl-draw-cold',
    'mapbox-gl-draw-hot',
];

const layers = [
    'gl-draw-line',
    'gl-draw-polygon-fill',
    'gl-draw-polygon-midpoint',
    'gl-draw-polygon-stroke-active',
    'gl-draw-polygon-and-line-vertex-halo-active',
    'gl-draw-polygon-and-line-vertex-active',
    'gl-draw-line-static',
    'gl-draw-polygon-fill-static',
    'gl-draw-polygon-stroke-static',
];

export {
    sources,
    layers,
};

export default [
    {
        id: 'highlight-active-points',
        type: 'circle',
        filter: [ 'all',
            [ '==', '$type', 'Point' ],
            [ '==', 'meta', 'feature' ],
            [ '==', 'active', 'true' ],
        ],
        paint: {
            'circle-radius': 8,
            'circle-color': Yellow,
        },
    },
    {
        id: 'points-are-blue',
        type: 'circle',
        filter: [ 'all',
            [ '==', '$type', 'Point' ],
            [ '==', 'meta', 'feature' ],
            [ '==', 'active', 'false' ],
        ],
        paint: {
            'circle-radius': 10,
            'circle-color': '#333',
        },
    },
    {
        id: 'gl-draw-line',
        type: 'line',
        filter: [ 'all', [ '==', '$type', 'LineString' ], [ '!=', 'mode', 'static' ] ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#333',
            'line-width': 2,
        },
    },
    {
        id: 'gl-draw-polygon-fill',
        type: 'fill',
        filter: [ 'all', [ '==', '$type', 'Polygon' ], [ '!=', 'mode', 'static' ] ],
        paint: {
            'fill-color': Yellow,
            'fill-outline-color': Yellow,
            'fill-opacity': 0.4,
        },
    },
    {
        id: 'gl-draw-polygon-midpoint',
        type: 'circle',
        filter: [
            'all',
            [ '==', '$type', 'Point' ],
            [ '==', 'meta', 'midpoint' ],
        ],
        paint: {
            'circle-radius': 5,
            'circle-color': Yellow,
        },
    },
    {
        id: 'gl-draw-polygon-stroke-active',
        type: 'line',
        filter: [ 'all', [ '==', '$type', 'Polygon' ], [ '!=', 'mode', 'static' ] ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': '#FFF',
            'line-dasharray': [ 0.2, 2 ],
            'line-width': 2,
        },
    },
    {
        id: 'gl-draw-polygon-and-line-vertex-halo-active',
        type: 'circle',
        filter: [ 'all', [ '==', 'meta', 'vertex' ], [ '==', '$type', 'Point' ], [ '!=', 'mode', 'static' ] ],
        paint: {
            'circle-radius': 0,
            'circle-color': Yellow,
        },
        layout: {
        },
    },
    {
        id: 'gl-draw-polygon-and-line-vertex-active',
        type: 'circle',
        filter: [ 'all', [ '==', 'meta', 'vertex' ], [ '==', '$type', 'Point' ], [ '!=', 'mode', 'static' ] ],
        paint: {
            'circle-radius': 8,
            'circle-color': Yellow,
        },
    },
    {
        id: 'gl-draw-line-static',
        type: 'line',
        filter: [ 'all', [ '==', '$type', 'Polygon' ] ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': Yellow,
            'line-width': 3,
        },
    },
    {
        id: 'gl-draw-polygon-fill-static',
        type: 'fill',
        filter: [ 'all', [ '==', '$type', 'Polygon' ], [ '==', 'mode', 'static' ] ],
        paint: {
            'fill-color': Yellow,
            'fill-outline-color': Yellow,
            'fill-opacity': 0.4,
        },
    },
    {
        id: 'gl-draw-polygon-stroke-static',
        type: 'line',
        filter: [ 'all', [ '==', '$type', 'Polygon' ], [ '==', 'mode', 'static' ] ],
        layout: {
            'line-cap': 'round',
            'line-join': 'round',
        },
        paint: {
            'line-color': Yellow,
            'line-width': 3,
        },
    },
];
